import type { FC } from 'react';

import { useGooglePlacesApi } from '@nodal/core/hooks/useGooglePlacesApi';
import { LoadingScreen } from '@nodal/uikit/components/LoadingScreen';
import pickBy from 'lodash/pickBy';

import { useContactDetailsForm } from '../useContactDetailsForm';
import { useOrganizationDetails } from '../useOrganizationDetails';
import { useProfileDetails } from '../useProfileDetails';

import { NonBusinessContactDetails } from './NonBusinessContactDetails';
import { schema as validationSchema } from './validation';

import type { ContactDetailsValues } from './NonBusinessContactDetails.interface';

export const NonBusinessContactDetailsConnected: FC = () => {
  const placesApiReady = useGooglePlacesApi();
  const { profile, updateProfile } = useProfileDetails();
  const { updateOrganization } = useOrganizationDetails();

  const submit = async (submitData: ContactDetailsValues) => {
    const { id, first_name, last_name } = submitData;

    const organizationData = {
      ...pickBy(submitData, (value, key) =>
        ['phone_number', 'address'].includes(key),
      ),
      name: `${first_name} ${last_name}`,
    };

    const profileData = pickBy(submitData, (value, key) =>
      ['first_name', 'last_name'].includes(key),
    );

    await Promise.all([
      updateProfile(profileData),
      updateOrganization(id!, organizationData),
    ]);
  };

  const { onSubmit } = useContactDetailsForm({ submit });

  const { organization } = useOrganizationDetails();

  if (!profile || !organization || !placesApiReady) {
    return <LoadingScreen />;
  }

  return (
    <NonBusinessContactDetails
      onSubmit={onSubmit}
      initialValues={{
        ...profile,
        ...organization,
      }}
      validationSchema={validationSchema}
    />
  );
};
